<app-epg (sendUrlChannel)="setUrlChannel($event)"></app-epg>
